export default "__VITE_ASSET__CTbeGolD__"